export default __webpack_public_path__ + "static/media/warning-mark-red.16fff9aa.svg";